import Vue from 'vue';
import i18n from './i18n';
import App from './App.vue';
import Buefy from 'buefy';
import 'buefy/dist/buefy.css';
import Globalize from 'globalize';
import VueGlobalize from 'vue-globalize';

Vue.config.productionTip = false;

Vue.use(Buefy);

Vue.use(VueGlobalize, {
  defaultCategories: ['main', 'supplemental'],
  loadGlobalize: function(locale, categories, globalize, callback) {
  }
});

let vue = new Vue({
  i18n,
  render: h => h(App),
}).$mount('#app');

vue.$setLocale('en');

let uri = window.location.search.substring(1); 
let params = new URLSearchParams(uri);
if (params.get('lang')) {
  let locale = params.get('lang');
  //vue.$setLocale(lang);
  vue.$i18n.locale = locale;
  vue.$root.$i18n.locale = locale;
}
